<template>
  <div>
    <div class="w100" v-if="siftData.length > 0">
      <SiftComp ref="sift" :sift-data="siftData" :loading="loading" @click-search="fetchData" />
    </div>

    <div class="w100 pb20 cl-f">
      <div class="fr pr10">
        <el-button v-if="appData" @click="$emit('click-collect', appData.isCollect)" :loading="collecting">
          <i class="yellow" :class="appData.isCollect ? 'el-icon-star-on' : 'el-icon-star-off'"></i>
          {{ appData.isCollect ? '取消收藏' : '点击收藏' }}
        </el-button>
        <el-button v-if="siftData.length > 0" type="warning" :loading="loading" @click="download">导出</el-button>
        <el-button v-if="siftData.length > 0" type="primary" :loading="loading" @click="fetchData()">查询</el-button>
        <a class="none" id="downloadExcel" download="excel.xls"></a>
      </div>
    </div>

    <section v-if="listData">
      <p class="w100 pb20 tx-c font-16">{{ listData.xm }}的课表</p>
      <table class="w100 tx-c table">
        <tr>
          <td>时间段</td>
          <td>节点</td>
          <td>周一</td>
          <td>周二</td>
          <td>周三</td>
          <td>周四</td>
          <td>周五</td>
          <td>周六</td>
          <td>周日</td>
        </tr>
        <tr v-for="index in 11" :key="index">
          <td style="width: 30px;" v-if="index == 1 || index == 6 || index == 9" :rowspan="index == 1 ? 5 : 3">{{ index == 1 ? '上午' : (index == 6 ? '下午' : '晚上') }}</td>
          <td style="width: 30px;">{{ index }}</td>
          <td style="max-width: 130px;" v-for="(val, key) in listData.list" :key="key" :rowspan="rowSpan(val, index)" v-show="rowSpan(val, index)">
            <span v-for="(v, k) in val" :key="k" rowspan="">
              <p class="pt5 pb5" v-if="index == v.firstIndex">
                {{ v.value }}
              </p>
            </span>
          </td>
        </tr>
      </table>
    </section>
    <p v-else class="w100 pb20 grey tx-c">暂无数据</p>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import SiftComp from "@/components/CompSift/SiftComp";

export default {
  name: "StuCourse",
  components: {
    SiftComp
  },
  props: ["url", "app-data", "collecting"],
  data() {
    return {

      loading: false,
      error: "",

      siftData: [],
      labelData: [],

      listData: null
    };
  },
  computed: {
    ...mapState(["userData", "userToken"])
  },
  created() {},
  mounted() {
    this.fetchSiftData();
  },
  methods: {
    rowSpan(arr, index) {
      let num = 1;
      for (const item of arr) {
        if (index == item.firstIndex) {
          num = item.lastIndex - item.firstIndex + 1;
          break;
        } else if (index > item.firstIndex && index <= item.lastIndex) {
          num = 0;
          break;
        }
      }
      return num;
    },
    fetchSiftData() {
      this.loading = true;

      this.$http
        .post(
          this.$route.query.interfaceUrl + `/getTitleData`,
          this.$qs.stringify({
            userId: this.userData.userId,
            id: this.$route.query.id
          })
        )
        .then(({ data }) => {
          // console.log(data);
          if (data.resCode == 0 && data.resStatus == 0) {
            if (data.resData.siftData) {
              this.siftData = data.resData.siftData;
            }
            if (data.resData.labelData) {
              this.labelData = data.resData.labelData;
            }
            this.$nextTick(() => {
              this.fetchData();
            });
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.error = 404;
          this.$notify({
            title: "错误",
            message: "网络请求错误，请检查网络",
            type: "error",
            offset: 60
          });

          this.loading = false;
        });
    },
    fetchData() {
      let obj = {};
      if (this.siftData.length > 0) {
        obj = this.$refs.sift.clickSearchBtn();
      }

      obj.userId = this.userData.userId;
      obj.pageNum = this.page;
      obj.pageSize = this.size;

      this.loading = true;
      this.$http
        .post(
          this.$route.query.interfaceUrl + `/query`,
          this.$qs.stringify(obj)
        )
        .then(({ data }) => {
          if (data.resCode == 0 && data.resStatus == 0) {
            // console.log(data.resData);
            this.listData = data.resData ? data.resData : null;
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "网络请求错误，请检查网络",
            type: "error",
            offset: 60
          });
          this.loading = false;
        });
    },
    download() {
      let obj = {};
      if (this.siftData.length > 0) {
        obj = this.$refs.sift.clickSearchBtn();
      }
      obj.token = this.userToken;

      this.$http
        .get(this.$route.query.interfaceUrl + "/exportData", {
          params: obj,
          responseType: "blob"
        })
        .then(({ data }) => {
          // console.log(data);
          if (!data) {
            return;
          }
          document.getElementById(
            "downloadExcel"
          ).href = window.URL.createObjectURL(data);
          document.getElementById("downloadExcel").click();
          return;
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "网络请求错误，请检查网络",
            type: "error",
            offset: 60
          });
        });
    }
  }
};
</script>

<style scoped>
.table {
  border-collapse: collapse;
}

.table tr:first-child td {
  background: #f6f6f6;
}

.table td {
  border: 1px solid #ccc;
  padding: 20px;
}
</style>
